import { CFormGroup, CInput, CInvalidFeedback, CLabel } from "@coreui/react";

import React from "react";
import { FieldError } from "react-hook-form";

interface TextFieldProps {
  name: string;
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  error?: FieldError;
  required?: boolean;
  placeholder?: string;
  testId?: string;
}

const TextField: React.FC<TextFieldProps> = ({
  name,
  label,
  description,
  value,
  onChange,
  error,
  required = false,
  placeholder,
  testId,
}) => {
  return (
    <CFormGroup>
      <CLabel htmlFor={name}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </CLabel>
      {description && (
        <small className="form-text text-muted mb-2">{description}</small>
      )}
      <CInput
        id={name}
        name={name}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange((e.target as HTMLInputElement).value)}
        placeholder={placeholder}
        invalid={!!error}
      />
      {error && <CInvalidFeedback>{error.message}</CInvalidFeedback>}
    </CFormGroup>
  );
};

export default TextField;
